import React from 'react';
import FastFacts from './fast-facts';

/**
* This is the preview component for the Fast Facts block.
* It renders a group of cards with an icon, title, and text.
*/
const FastFactsPreview = ({ attributes }) => {
  const { cards, textColorClass, headingColorClass, title } = attributes;

  // console.log("FastFactsPreview attributes:", { title, textColorClass, headingColorClass, cards });

  return (
    <FastFacts
      title={title}
      cards={cards}
      textColorClass={textColorClass}
      headingColorClass={headingColorClass}
    />
  );
}

export default FastFactsPreview;
